import React from 'react';
import PropTypes from 'prop-types';

import {SportImage} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column2/SportImage';
import {round} from '@utils/round';
import {
    EVENT_TYPE_SPORTRADAR,
    EVENT_TYPE_NON_SPORTRADAR,
    EVENT_TYPE_STAGE,
} from '@constants/variables';
import {convertToInt} from '@utils/helpers';

import {category} from '../fields/column2/category';
import {firstLevelCategory} from '../fields/column2/firstLevelCategory';
import {firstStageCategory} from '../fields/column2/firstStageCategory';
import {secondLevelCategory} from '../fields/column2/secondLevelCategory';
import {secondStageCategory} from '../fields/column2/secondStageCategory';
import {sport} from '../fields/column2/sport';
import {stageSport} from '../fields/column2/stageSport';
import {thirdLevelCategory} from '../fields/column2/thirdLevelCategory';
import {tournament} from '../fields/column2/tournament';

export const EVENT_TYPE_LABELS = {
    [EVENT_TYPE_SPORTRADAR]: 'Sportradar',
    [EVENT_TYPE_NON_SPORTRADAR]: 'Non-Sportradar',
    [EVENT_TYPE_STAGE]: 'Stage',
};

export const getEventType = (eventTypeId) => {
    const id = convertToInt(eventTypeId);

    return EVENT_TYPE_LABELS[id];
};

const ROWS_CONFIG = {
    [EVENT_TYPE_LABELS[EVENT_TYPE_SPORTRADAR]]: [
        {name: 'Sport', value: sport},
        {name: 'Category', value: category},
        {name: 'Tournament', value: tournament},
    ],
    [EVENT_TYPE_LABELS[EVENT_TYPE_NON_SPORTRADAR]]: [
        {name: '1st level category', value: firstLevelCategory},
        {name: '2nd level category', value: secondLevelCategory},
        {name: '3rd level category', value: thirdLevelCategory},
    ],
    [EVENT_TYPE_LABELS[EVENT_TYPE_STAGE]]: [
        {name: 'Sport', value: stageSport},
        {name: '1st stage category', value: firstStageCategory},
        {name: '2nd stage category', value: secondStageCategory},
    ],
};

export const getFieldsList = (event) => {
    const typeId = getEventType(event.event_type.id);
    const config = ROWS_CONFIG[typeId];

    const fieldsColumn = config.map((row, idx) => ({
        name: row.name,
        value: row.value(event),
        image: 0 === idx && EVENT_TYPE_LABELS[EVENT_TYPE_NON_SPORTRADAR] !== typeId
            ? <SportImage event={event}/> : null,
    }));

    fieldsColumn.push(
        {
            name: 'Round',
            value: round(event),
        }
    );

    return fieldsColumn;
};

getFieldsList.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.object,
    }),
};

getFieldsList.defaultProps = {
    event: {
        sr_event: null,
    },
};
